import React from 'react';
import Sidebar from './Sidebar';
import TopBar from './TopBar';
import { StaffBanner } from '@/components/common/StaffBanner';

interface DashboardLayoutProps {
  children: React.ReactNode;
}

const DashboardLayout: React.FC<DashboardLayoutProps> = ({ children }) => {
  return (
    <div className="min-h-screen bg-background flex flex-col">
      <StaffBanner />
      <div className="flex flex-1">
        <Sidebar />
        <div className="flex-1 ml-[72px]">
          <TopBar />
          <main className="p-6">
            {children}
          </main>
        </div>
      </div>
    </div>
  );
};

export default DashboardLayout;
